import 'swiper/css/bundle';
import Swiper from 'swiper';
import { Navigation, EffectCreative, Pagination } from 'swiper/modules';

Swiper.use([Navigation, EffectCreative, Pagination]);

const heroSwiper = new Swiper('.hero-swiper', {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
        el: ".hero-pagination",
        clickable: 'true',
    },
    breakpoints: {
        810: {
            slidesPerView: 2,
        },
        1250: {
            slidesPerView: 3,
        },
    },
});